'use client'

import { createContext, useContext } from 'react'

export type OnetalkWidgetStatus = 'loading' | 'ready' | 'unavailable'

type OnetalkWidgetContextValue = {
  status: OnetalkWidgetStatus
  open: () => void
  prepare: () => void
}

const openLoadedWidget = () => {
  const openOnetalk = window.Onetalk?.open?.bind(window.Onetalk)
  if (!openOnetalk) {
    return
  }

  try {
    void Promise.resolve(openOnetalk()).catch(() => undefined)
  } catch {
    // 원톡 장애가 페이지 이동이나 앱 동작에 영향을 주지 않도록 호출 실패만 무시한다.
  }
}

const OnetalkWidgetContext = createContext<OnetalkWidgetContextValue>({
  status: 'loading',
  open: openLoadedWidget,
  prepare: () => undefined,
})

export const OnetalkWidgetStatusProvider = OnetalkWidgetContext.Provider

export const useOnetalkWidgetStatus = () => useContext(OnetalkWidgetContext).status

export const useOpenOnetalkWidget = () => useContext(OnetalkWidgetContext).open

export const usePrepareOnetalkWidget = () => useContext(OnetalkWidgetContext).prepare
